import React from "react";
import github from "../../image/github-6-xxl.png";
import mongo from "../../image/mongo.png";
import firebase from "../../image/firebase.png";
import heroku from "../../image/heroku.png";
import { Grid, Typography } from "@material-ui/core";
import { Container } from "@mui/material";
import "./OtherSkills.css";

const OtherSkills = () => {
  return (
    <>
      <br />
      <br />
      <Container>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div>
            <Typography
              variant="h4"
              style={{ color: "#fff", marginTop: "2em" }}
            >
              {" "}
              Other Skills
            </Typography>
            <div
              style={{
                borderBottom: "2px solid #fff",
                display: "flex",
                justifyContent: "center",
                marginBottom: "1em",
              }}
            ></div>
          </div>
        </div>
        <br />
        <br />
        <Grid container spacing={2}>
          <Grid className="img-skill" item xs={12} md={3}>
            <div className="img-item">
              <img src={github} alt="img" />
            </div>
          </Grid>
          <Grid className="img-skill" item xs={12} md={3}>
            <div className="img-item">
              {" "}
              <img src={firebase} alt="img" />
            </div>
          </Grid>
          <Grid className="img-skill" item xs={12} md={3}>
            <div className="img-item">
              <img src={heroku} alt="img" />
            </div>
          </Grid>
          <Grid className="img-skill" item xs={12} md={3}>
            <div className="img-item">
              <img src={mongo} alt="img" />
            </div>
          </Grid>
        </Grid>
      </Container>
      <br />
      <br />
    </>
  );
};

export default OtherSkills;
